import styled from 'styled-components';

const CustomDateRange = styled.div`
  padding-bottom: ${(props): string => props.theme.spaces.xl};
  display: grid;
  grid-template-columns: 3rem max-content auto;

  border-bottom: 0.1rem solid
    ${(props): string => props.theme.colors.heatherGray};
  > div:first-child {
    width: 3rem;
  }

  > div {
    width: 15rem;
    input {
      width: 15rem;
      min-width: 15rem;
    }
  }

  > div:last-child {
    margin-left: 2.8rem;
    width: 50rem;
    position: relative;
  }

  .endDate {
    margin-left: 4rem;
    margin-top: 0.5rem;
  }
`;

export { CustomDateRange };
